import { orderIsFreeDutiesEligible } from "../../utils/orderIsFreeDutiesEligible";
import { TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE } from "./shared";
export var DutiesInvoiceIA = function DutiesInvoiceIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_NOT_SELECTED(strictLocalize);
  }
  return orderIsFreeDutiesEligible(brandOrder) ? DUTIES_FREE_ORDER(strictLocalize) : NON_DUTIES_FREE_ORDER(strictLocalize);
};
var ORDER_NOT_SELECTED = function ORDER_NOT_SELECTED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE(strictLocalize), YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_FREE_ORDER = function DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var NON_DUTIES_FREE_ORDER = function NON_DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_INVOICES_WITH_FAIRE = function DUTIES_INVOICES_WITH_FAIRE(strictLocalize) {
  return strictLocalize({
    id: "GUFPUU",
    defaultMessage: [{
      "type": 0,
      "value": "Faturas de direitos aduaneiros com a Faire"
    }]
  });
};
var ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE = function ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE(strictLocalize) {
  return strictLocalize({
    id: "nV464S",
    defaultMessage: [{
      "type": 0,
      "value": "Todas as encomendas que incluem produtos elegíveis para direitos aduaneiros geram uma fatura de direitos aduaneiros. Se os direitos aduaneiros estiverem cobertos para a sua encomenda, aplicaremos um desconto à sua fatura durante o check-out que reflete o custo estimado dos direitos aduaneiros de importação da sua encomenda. Quando a encomenda for enviada, a transportadora enviar-lhe-á uma fatura de todos os custos de importação (incluindo os direitos aduaneiros de importação e o IVA) que pagará na íntegra. Se os direitos aduaneiros estiverem cobertos e o custo real dos direitos aduaneiros de importação e das taxas de desembolso for superior à promoção de direitos aduaneiros que recebeu, pode solicitar o reembolso da diferença em crédito Faire quando a encomenda for entregue."
    }]
  });
};
var YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES = function YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES(strictLocalize) {
  return strictLocalize({
    id: "XjOUVq",
    defaultMessage: [{
      "type": 0,
      "value": "Se os direitos aduaneiros não estiverem cobertos para a sua encomenda, será responsável pelas taxas de direitos aduaneiros."
    }]
  });
};
var ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "C5Am+H",
    defaultMessage: [{
      "type": 0,
      "value": "Esta encomenda é elegível para a promoção de direitos aduaneiros gratuitos. Todas as encomendas que incluem produtos elegíveis para direitos aduaneiros geram uma fatura de direitos aduaneiros. Como os direitos aduaneiros estão cobertos para a sua encomenda, aplicaremos um desconto à sua fatura durante o check-out que reflete o custo estimado dos direitos aduaneiros de importação da sua encomenda. Quando a encomenda for enviada, a transportadora enviar-lhe-á uma fatura de todos os custos de importação (incluindo os direitos aduaneiros de importação e o IVA) que pagará na íntegra. Se o custo real dos direitos aduaneiros de importação e das taxas de desembolso for superior à promoção de direitos aduaneiros que recebeu, pode solicitar o reembolso da diferença em crédito Faire quando a encomenda for entregue."
    }]
  });
};
var ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "0Ut9wH",
    defaultMessage: [{
      "type": 0,
      "value": "Esta encomenda não é elegível para a promoção de direitos aduaneiros gratuitos. Todas as encomendas que incluem produtos elegíveis para direitos aduaneiros geram uma fatura de direitos aduaneiros. Como os direitos aduaneiros não estão cobertos para a sua encomenda, será responsável pelas taxas de direitos aduaneiros. Quando a encomenda for enviada, a transportadora enviar-lhe-á uma fatura de todos os custos de importação (incluindo os direitos aduaneiros de importação e o IVA) que pagará na íntegra."
    }]
  });
};